import type { SpaceUserDocument, SpaceUserRole } from "popopo-msg"
import { assertNever } from "popopo-lib-common"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import type { User } from "firebase/auth"
import { api } from "../../core"

type SpaceRoleSwitchForms = {
  role: SpaceUserRole
}

export const SpaceRoleDebugSwitchButton = (props: { firebase: User; spaceUser: SpaceUserDocument }) => {
  const nextRole = (role: SpaceUserRole) => {
    switch (role) {
      case "owner":
        return "moderator"
      case "moderator":
        return "member"
      case "member":
        return "owner"
      default:
        return assertNever(role)
    }
  }
  const form = useForm<SpaceRoleSwitchForms>({
    mode: "onBlur",
    defaultValues: {
      role: nextRole(props.spaceUser.role),
    },
  })
  useEffect(() => {
    form.setValue('role', nextRole(props.spaceUser.role))
  }, [props.spaceUser, form])
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async (value: SpaceRoleSwitchForms) => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.PUT("/api/v2/debug/spaces/{space_key}/users/{user_id}/role", {
        params: {
          path: { space_key: props.spaceUser.space_key, user_id: props.spaceUser.id },
        },
        headers: {
          authorization: `Bearer ${idToken}`,
        },
        body: value,
      })
      form.setValue('role', nextRole(value.role))
    } catch (e) {
      console.error(e)
      throw e
    }
  }

  return (
    <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
      <button type="submit" className="btn btn-danger form-control" disabled={isSubmitting || !isValid}>
        Switch role to {form.watch('role')}
      </button>
    </form>
  )
}
